import { create } from "zustand"

export type MessageType = "user" | "ai"

export interface LessonMessage {
  id: string
  content: string
  type: MessageType
}

interface LessonMessageState {
  messages: LessonMessage[]
  displayButtons: boolean
  approved: boolean
  indications: string[]
  studySessionId: string
  finalLesson: boolean

  setMessages: (message: LessonMessage) => void
  setDisplayButtons: (displayButtons: boolean) => void
  setApproved: (approved: boolean) => void
  setIndications: (indications: null | string[]) => void
  setStudySessionId: (studySessionId: string) => void
  setFinalLesson: (finalLesson: boolean) => void
  clearState: () => void
}

export const useLessonsMessages = create<LessonMessageState>((set) => ({
  messages: [],
  displayButtons: false,
  approved: false,
  indications: [],
  studySessionId: "",
  finalLesson: false,

  setMessages: (message: LessonMessage) =>
    set((state) => ({ messages: [...state.messages, message] })),
  setDisplayButtons: (displayButtons: boolean) => set({ displayButtons }),
  setApproved: (approved: boolean) => set({ approved }),
  setIndications: (indications: null | string[]) => set({ indications: indications || [] }),
  setStudySessionId: (studySessionId: string) => set({ studySessionId }),
  setFinalLesson: (finalLesson: boolean) => set({ finalLesson }),
  clearState: () =>
    set({
      messages: [],
      displayButtons: false,
      approved: false,
      indications: [],
      studySessionId: "",
      finalLesson: false,
    }),
}))
